import React from "react";
import { Container, Row } from "react-bootstrap";
import Header from "../../modules/header/Header";

import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import useForceUpdate from "use-force-update";
import "../../../styles/App.css";

import style from "./FrontLayout.module.css";
//pages
import LoginPage from "../../pages/auth/Login";
import MySignaturePage from "../../pages/MySignature";
import EditorPage from "../../pages/Editor";

import routes from "../../../assets/lang/routes";

export default function FrontLayout() {
  const [checkStorage, setCheckStorage] = useState(
    localStorage.getItem("auth_token") ? true : false
  );
  const forceUpdate = useForceUpdate();
  const location = useLocation();

  function getDesignLayout() {
    if (location.pathname === "/login") {
      return (
        <div className="vh-100">
          <main>
            <Container style={{ position: "fixed", left: "38%", top: "25%" }}>
              <Row>
                <Routes>
                  <Route
                    path={`${routes.login}`}
                    element={
                      !localStorage.getItem("auth_token") ? (
                        <LoginPage />
                      ) : (
                        <Navigate to={`${routes.editor}`} />
                      )
                    }
                  />
                </Routes>
              </Row>
            </Container>
          </main>
        </div>
      );
    } else {
      return (
        <div className="vh-100 position-relative">
          <Header />
          <div className="d-flex flex-wrap">
            <Routes>
              <Route path="/*" element={<Navigate to={`${routes.editor}`} />} />
              <Route path={`${routes.login}`} element={<LoginPage />} />
              <Route path={`${routes.editor}`} element={<EditorPage />} />
              <Route
                path="/my-signatures"
                element={
                  localStorage.getItem("auth_token") ? (
                    <MySignaturePage />
                  ) : (
                    <Navigate to={`${routes.editor}`} />
                  )
                }
              />
            </Routes>
          </div>
          {/* < Footer /> */}
        </div>
      );
    }
  }

  useEffect(() => {
    function handleStorage() {
      setCheckStorage(localStorage.getItem("auth_token") ? true : false);
    }
    window.addEventListener("storage", handleStorage);
    forceUpdate();
    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [checkStorage]);
  return <>{getDesignLayout()}</>;
}
